import { atom } from 'jotai';
import {
  TValidationType,
  ValidationDismissalReason,
} from '../types/validation-types';

// Mark validation types - similar to review but without dataset property
export interface IMarkValidation {
  id: number;
  label: string;
  error: string | null;
  error_detail: string | null;
  dismissal_reason: ValidationDismissalReason | null;
}

export interface IMarkValidationForDocument {
  id: string; // document id
  results: IMarkValidation[];
}

export interface IMarkValidationErrorDetails {
  id: number;
  field: string;
  error: string | null;
  errorDetail: string | null;
  type: TValidationType;
  dismissalReason?: ValidationDismissalReason | null;
}

export interface IMarkValidationByDocument {
  documentId: string;
  hasValidationResponse: boolean;
  validationErrorsList: TValidationType[];
  validationErrorDetails: IMarkValidationErrorDetails[];
}

// Atom to store validation results by document ID
export const markValidationByDocumentAtom = atom<IMarkValidationByDocument[]>([]);

// Toggle for whether validation is enabled in marking
export const markValidationsEnabledAtom = atom<boolean>(true);

// Toggle for whether to show validation errors in the UI
export const markShowValidationsAtom = atom<boolean>(true);

// Toggle for showing the "View All Validation Errors" dialog in marking
export const showMarkValidationErrorsDialogAtom = atom<boolean>(false);
